export default class perfilextencioncotroller{

    constructor($scope,$uiGridConstants,$http,perfilSrv,ngNotify,UserInfoConstant, $cookies, $stateParams,$state, i18nService){
        this.$scope = $scope;
        this.$uiGridConstants = $uiGridConstants;
        this.$http = $http;
        this.perfilSrv = perfilSrv;
        this.ngNotify = ngNotify;
        this.$cookies = $cookies;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$scope.gridOptionsComplex = {
            enableFiltering: true,
            enableGridMenu: true,
            showFooter: true,
            enableRowSelection: true,
            enableRowHeaderSelection: false,
            multiSelect: false,
            modifierKeysToMultiSelect: false,
            noUnselect: true,
            //rowHeight: 36,
            columnDefs: [
                { displayName: 'Campo/Descripción',field:'campoDescripcion', width: '25%' },
                { displayName: 'Servicio',field:'servico', width: '15%' },
                { displayName: 'A Título',field:'aTitulo', width: '15%' },
                { displayName: 'Objeto',field:'objeto', width: '15%' },
                { displayName: 'Mes/Año Inicio',field:'mesAnoInicio', width: '15%' },
                { displayName: 'Mes/Año Finalización',field:'mesAnoFinalizacion', width: '25%' },
                { displayName: 'Tipo De Entidad',field:'tipoDeEntidad', width: '15%' },
                { displayName: 'Ent. Contratante',field:'entContratante', width: '15%' },
                { displayName: 'Resultados',field:'resultados', width: '15%' }
            ]
        };
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
        i18nService.setCurrentLang('es')
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.perfilextention(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    } else {
                        this.$state.go('profile.perfil_dash');
                        this.ngNotify.set('No se ha especificado ningún docente', 'info');
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    goBack(){
        this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.perfilextention(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    perfilextention(teacherId) {
        this.perfilSrv.perfildocente.perfilextention({teacherId:teacherId}).$promise.then((dataReturn) => {   
            this.$scope.gridOptionsComplex.data  = dataReturn.data;
        }, (data) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

}

perfilextencioncotroller.$inject = ['$scope','uiGridConstants','$http','perfilSrv','ngNotify','UserInfoConstant','$cookies', '$stateParams', '$state', 'i18nService'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_extencion/perfilextencioncotroller.js